
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card loading\">\n  <section>\n    <div class=\"error\"></div>\n\n    <div class=\"spinner\"></div>\n  </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/loading.mustache
// module id = 162
// module chunks = app